import { css } from '@repo/pandacss/css';

/** Position within a related set of choices (W3C checkbox / radiogroup list pattern). */
export function getChoiceSetPositionProps(index: number, total: number) {
  return {
    'aria-setsize': total,
    'aria-posinset': index + 1,
  } as const;
}

/** Unstyled list wrapper so assistive tech can expose "item N of M" in a group. */
export const choiceListClass = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '[1.25rem]',
  listStyle: 'none',
  padding: '0',
  margin: '0',
});

export const choiceListItemClass = css({
  display: 'flex',
  minWidth: '[0]',
});
